import React from 'react';
import dynamic from 'next/dynamic';

const DotLottieReact = dynamic(() => import('@lottiefiles/dotlottie-react').then((m) => m.DotLottieReact), {
  ssr: false,
});

type LoadingProps = {
  color?: 'red' | 'white';
  size?: number;
  loop?: boolean;
};

const loadingRed = '/lottie/loader_progress_red.lottie';
const loadingWhite = '/lottie/loader_progress_white.lottie';

const LoadingIcon: React.FC<LoadingProps> = ({ color = 'red', size = 48, loop = false }) => (
  <DotLottieReact
    src={color === 'red' ? loadingRed : loadingWhite}
    autoplay
    loop={loop}
    style={{ width: size, height: size }}
  />
);

export default LoadingIcon;
